<div class="show-downloads-container">
  <div *ngIf="downloadData$ | async as downloadData">
    <div *ngIf="downloadData.length; else noDownloadsAvailable">
      <h3>Download Assets:</h3>
      <button mat-raised-button class="btn btn-green" (click)="downloadAllAssets(downloadData)">Download All ({{downloadSizes['all'] | number:'1.0-2'}} MB)</button>
      <div class="download-btn-list" *ngFor="let download of downloadData; let i = index">
        <button mat-raised-button
                [ngClass]="!!download[1][0]?.path?.split('_')[2] && download[1][0]?.path?.split('_')[2].startsWith('rejection/') ? 'btn btn-red' : 'btn btn-blue'"
                (click)="downloadFile(download, i + 1)">
          {{i + 1}} ({{downloadSizes[download[0]] | number: '1.0-2'}} MB)
        </button>
        {{download[0] | date:'yyyy/MM/d, h:mm a'}}
      </div>
    </div>
    <ng-template #noDownloadsAvailable>
      <h4>Your download is still being processed. Please check again soon.</h4>
    </ng-template>
  </div>
</div>
